import { array, create, number, string, min, size, type } from 'superstruct';
export const PayloadItem = type({
    lineItemKey: size(string(), 10, Infinity),
    quantity: min(number(), 0)
});
export const Payload = type({
    items: size(array(PayloadItem), 1)
});
export const makeChangeItemQuantity = function(agent) {
    return async function changeItemQuantity(rawPayload) {
        const { items  } = create(rawPayload, Payload);
        const updates = items.reduce((acc, { lineItemKey: id , quantity  })=>{
            acc[id] = quantity;
            return acc;
        }, {});
        await agent.post('/cart/update.js', {
            json: {
                updates
            }
        }).json();
    };
};
